// extracted by mini-css-extract-plugin
export default {"values":"Values_values__bBYRk","card":"Values_card__-9JRy","valuesList":"Values_valuesList__p8rA9","bottomtopup":"Values_bottomtopup__l8x1T"};